import { openDB, type DBSchema, type IDBPDatabase } from "idb";
import type { Op } from "./ops";

/** IndexedDB van de app: offline-wachtrij, foto's die nog niet zijn geüpload, en de querycache. */
interface PwDb extends DBSchema {
  ops: { key: string; value: Op };
  blobs: { key: string; value: { fileId: string; blob: Blob; mime?: string } };
  kv: { key: string; value: string };
}

let dbp: Promise<IDBPDatabase<PwDb>> | null = null;

export function idb(): Promise<IDBPDatabase<PwDb>> {
  dbp ??= openDB<PwDb>("pw-offline", 1, {
    upgrade(db) {
      db.createObjectStore("ops", { keyPath: "id" });
      db.createObjectStore("blobs", { keyPath: "fileId" });
      db.createObjectStore("kv");
    },
  });
  return dbp;
}

/** Opslag voor de query-persister (TanStack Query). */
export const kvStorage = {
  getItem: async (key: string) => (await (await idb()).get("kv", key)) ?? null,
  setItem: async (key: string, value: string) => {
    await (await idb()).put("kv", value, key);
  },
  removeItem: async (key: string) => {
    await (await idb()).delete("kv", key);
  },
};
